export const textEditorInfo = {
    textEditorFormat: [
        "header",
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "color",
        "background",
        "align",
        "list",
        "bullet",
    ]
}